function nivelarDias(schedule) {
  return Object.values(schedule).reduce((acc, dayEntries) => {
    const validEntries = dayEntries.filter(
      (entry) => entry.start && entry.end
    );
    return acc.concat(validEntries);
  }, []);
}

const organizarDias = (listaHorarios) => {
  const tempHorarioTrabalho = {
    domingo: [],
    segunda: [],
    terca: [],
    quarta: [],
    quinta: [],
    sexta: [],
    sabado: [],
  };

  listaHorarios.forEach(({ nomeDiaSemana, start, end, id }) => {
    tempHorarioTrabalho[nomeDiaSemana].push({
      nomeDiaSemana,
      start: start || "",
      end: end || "",
      id,
    });
  });

  return tempHorarioTrabalho;
};

export { organizarDias, nivelarDias }